(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = ajax;

// ajax请求
function ajax(_ref) {
  var data = _ref.data,
      url = _ref.url,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'GET' : _ref$type,
      _success = _ref.success,
      _error = _ref.error;
  var requestData = data;

  if (requestData && type === 'POST') {
    requestData = JSON.stringify(requestData);
  }

  $.ajax({
    data: requestData,
    url: url,
    type: type,
    dataType: 'json',
    contentType: 'application/json; charset=utf-8',
    success: function success(e) {
      _success(e);
    },
    error: function error(e) {
      _error(e);
    }
  });
}

},{}],2:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.showTipsModal = showTipsModal;
exports.closeTipsModal = closeTipsModal;
var tipsModalCallback; // 显示提示弹窗

function showTipsModal(_ref) {
  var title = _ref.title,
      content = _ref.content,
      button = _ref.button,
      _ref$callback = _ref.callback,
      callback = _ref$callback === void 0 ? function func() {} : _ref$callback;
  $('#tipsModal').modal('show');
  $('#tipsModal .modal-title').text(title);
  $('#tipsModal .modal-body').text(content);
  $('#tipsModal .modal-footer button').text(button);
  tipsModalCallback = callback;
} // 关闭提示弹窗


function closeTipsModal() {
  $('#tipsModal').modal('hide');
  tipsModalCallback();
}

$('.tips-modal__button').click(function () {
  tipsModalCallback();
});

},{}],3:[function(require,module,exports){
"use strict";

var _ajax = _interopRequireDefault(require("../../common/js/ajax"));

var _tipsModal = require("../../components/tipsModal");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/* global gtag:true */
// 表单验证
function formValid() {
  $('#retrieveForm').validate({
    rules: {
      email: {
        required: true,
        email: true
      }
    },
    messages: {
      email: {
        required: $.i18n.prop('common.emailRequired'),
        email: $.i18n.prop('common.emailInvalid')
      }
    }
  });
} // 发送邮件


function sendEmail() {
  if ($('#retrieveForm').valid()) {
    (0, _ajax["default"])({
      data: {
        email: $('#email').val()
      },
      url: '/password/retrieve/send/email',
      success: function success(res) {
        if (res && res.success) {
          (0, _tipsModal.showTipsModal)({
            title: $.i18n.prop('common.tips'),
            content: $.i18n.prop('common.retrieveContent'),
            button: $.i18n.prop('common.ok')
          });
        } else {
          (0, _tipsModal.showTipsModal)({
            title: $.i18n.prop('common.tips'),
            content: res.errorMessage,
            button: $.i18n.prop('common.ok')
          });
        }
      }
    });
  }
} // 监听发送邮件按钮点击


function onSendEmailClick() {
  $('#sendEmail').click(function () {
    gtag('event', 'click', {
      event_category: '页面-找回密码',
      event_label: '发送身份验证邮件按钮'
    });
    sendEmail();
  });
} // 初始化


$(function () {
  // $.i18n.properties({
  //   name: 'messages',
  //   path: '/i18n/',
  //   mode: 'map',
  //   callback() {
  //     formValid();
  //     onSendEmailClick();
  //   },
  // });
  formValid();
  onSendEmailClick();
});

},{"../../common/js/ajax":1,"../../components/tipsModal":2}]},{},[3]);
